import NavbarSection from "@/components/LandingPage/Navbar/NavbarSection.vue";
import HeroSection from "@/components/LandingPage/Hero/HeroSection.vue";
import FeaturesSection from "@/components/LandingPage/Features/FeaturesSection.vue";
import FooterSection from "@/components/LandingPage/Footer/FooterSection.vue";

export default {
  name: "LandingPage",
  components: {
    NavbarSection,
    HeroSection,
    FeaturesSection,
    FooterSection,
  },
};
